<template>
  <!-- Loading state -->
  <div
    v-if="isLoading"
    class="flex justify-center items-center p-8"
  >
    <i class="pi pi-spin pi-spinner text-2xl text-blue-500" />
    <span class="ml-2 text-gray-600">Loading recent projects...</span>
  </div>
    
  <!-- Error state -->
  <div
    v-else-if="error"
    class="flex justify-center items-center p-8"
  >
    <div class="text-center">
      <i class="pi pi-exclamation-triangle text-2xl text-red-500 mb-2" />
      <p class="text-red-600">
        {{ error }}
      </p>
      <Button
        label="Retry"
        class="mt-2"
        @click="loadRecentProjects"
      />
    </div>
  </div>
    
  <!-- Projects table -->
  <ProjectsTable
    v-else
    :projects="projects"
    @refresh-projects="loadRecentProjects"
  />
</template>

<script setup>

import { ref, onMounted } from 'vue';

import ProjectsTable from '@/components/project/officeProject/ProjectDataTable.vue'
import { getRecentProjects } from '@/services/projectService';

const projects = ref([]);
const isLoading = ref(false);
const error = ref(null);

// Load recent projects from API
const loadRecentProjects = async () => {
    isLoading.value = true;
    error.value = null;
    
    try {
        const response = await getRecentProjects(5);
        projects.value = Array.isArray(response?.data) ? response.data : [];
    } catch (err) {
        error.value = 'Failed to load recent projects. Please try again.';
        console.error('Error loading recent projects:', err);
        projects.value = [];
    } finally {
        isLoading.value = false;
    }
};

// Populate projects when the component is mounted
onMounted(() => {
    loadRecentProjects();
});


</script>

<style scoped></style>